import { render, staticRenderFns } from "./RecipeInfo.vue?vue&type=template&id=5bdfe69c&scoped=true"
import script from "./RecipeInfo.vue?vue&type=script&lang=js"
export * from "./RecipeInfo.vue?vue&type=script&lang=js"
import style0 from "./RecipeInfo.vue?vue&type=style&index=0&id=5bdfe69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdfe69c",
  null
  
)

export default component.exports